(() => {
  const ARTICLE_SELECTOR = '.article-template__content';
  const CURRENCY = 'USD';
  const LOCALE = 'en-US';

  // ----- helpers -----
  const money = (cents) =>
    typeof cents === 'number'
      ? new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }).format(cents / 100)
      : '';

  const parseBlockHeader = (header) => {
    // e.g. "my-handle|sku=ABC|opt1=Blue|opt2=Large"
    const parts = header.split('|').map(p => p.trim()).filter(Boolean);
    const handle = parts.shift();
    const args = { handle };
    for (const p of parts) {
      const [k, v] = p.split('=');
      if (k && v) args[k.toLowerCase()] = v;
    }
    return args;
  };

  const fetchProduct = async (handle) => {
    const res = await fetch(`${Shopify.routes.root}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Product not found: ${handle}`);
    return res.json();
  };

  const findVariant = (product, args) => {
    const vars = product.variants || [];
    if (args.sku) {
      const bySku = vars.find(v => (v.sku || '').toLowerCase() === String(args.sku).toLowerCase());
      if (bySku) return bySku;
    }
    const want = ['opt1', 'opt2', 'opt3']
      .map(k => (args[k] || '').toLowerCase())
      .filter(Boolean);
    if (want.length) {
      const match = vars.find(v => {
        const vals = [v.option1, v.option2, v.option3].map(x => (x || '').toLowerCase());
        return want.every(w => vals.includes(w));
      });
      if (match) return match;
    }
    return vars.find(v => v.available) || vars[0] || null;
  };

  const atcUrl = (variantId, qty = 1) =>
    variantId ? `${Shopify.routes.root}cart/add?id=${encodeURIComponent(variantId)}&quantity=${encodeURIComponent(qty)}` : '';

  // ---- Token registry ----
  const tokenFns = {
    '##ITEMNAME##':        ({ product }) => product.title || '',
    '##PRODUCTNAME##':        ({ product }) => product.title || '',
    '##ITEMHANDLE##':      ({ product }) => product.handle || '',
    '##ITEMURL##':         ({ product }) => product.url || `/products/${product.handle}`,
    '##ITEMFULLURL##':         ({ product }) => product.url || `/products/${product.handle}`,
    '##ITEMPHOTOURL##':    ({ product }) => (product.images && product.images[0]) || '',
    '##ITEMPRICE##':       ({ variant }) => money(variant?.price),
    '##PRICE##':       ({ variant }) => money(variant?.price),
    '##ITEMCOMPAREAT##':   ({ variant }) => money(variant?.compare_at_price),
    '##ITEMSKU##':         ({ variant }) => variant?.sku || '',
    '##ITEMAVAIL##':       ({ variant }) => (variant?.available ? 'In stock' : 'Out of stock'),
    '##ITEMINVENTORYQTY##':({ variant }) => (typeof variant?.inventory_quantity === 'number' ? String(variant.inventory_quantity) : ''),
    '##ITEMADDTOCARTURL##':({ variant }) => atcUrl(variant?.id, 1),
  };

  const renderTokens = (html, ctx) => {
    for (const [token, fn] of Object.entries(tokenFns)) {
      if (html.includes(token)) {
        try { html = html.replaceAll(token, String(fn(ctx) ?? '')); } catch {}
      }
    }
    return html;
  };

  const stripSetMarkers = (html) =>
    html.replace(/##SETITEMBYHANDLE\[[^\]]+\]##\s*/g, '').replace(/##ENDSETITEM##/g, '');

  const transform = async (container) => {
    let html = container.innerHTML;
    const blockRe = /##SETITEMBYHANDLE\[([^\]]+)\]##([\s\S]*?)##ENDSETITEM##/g;

    const blocks = [];
    let m;
    while ((m = blockRe.exec(html)) !== null) {
      const [full, header, body] = m;
      blocks.push({ full, header, body });
    }
    if (!blocks.length) return;

    const cache = new Map();
    const getProduct = async (handle) => {
      if (!cache.has(handle)) cache.set(handle, fetchProduct(handle));
      return cache.get(handle);
    };

    for (const b of blocks) {
      try {
        const args = parseBlockHeader(b.header);
        const product = await getProduct(args.handle);
        const variant = findVariant(product, args);
        const ctx = { product, variant, args };

        let rendered = renderTokens(b.body, ctx);
        rendered = stripSetMarkers(rendered);

        html = html.replace(b.full, rendered);
      } catch (e) {
        console.warn('[Article shortcodes] Failed block:', b.header, e);
        html = html.replace(b.full, ''); // fail silently
      }
    }

    container.innerHTML = html;
  };

  const container = document.querySelector(ARTICLE_SELECTOR);
  if (container) transform(container);
})();
